/**
 * Мок сводки дашборда (числа синхронны дизайну Handoff 6). На BE заменит
 * `GET /admin/dashboard/summary?period=…` (ADMIN_BACKEND §7).
 */

import type {DashboardSummary} from './types';

export const DASHBOARD_SUMMARY: DashboardSummary = {
  dateLabel: '2 июля 2026',
  active: {total: 214, solo: 138, clinic: 76, deltaPct: 6.4},
  mrr: {
    value: 1_284_000,
    deltaPct: 12.4,
    deltaAbs: 141_200,
    spark: [820, 910, 880, 1010, 1060, 1090, 1150, 1200, 1170, 1240, 1265, 1284],
  },
  trial: {total: 37, noCard: 8, withCard: 29},
  risks: {trialExpired: 3, awaitingCard: 8, pastDue: 5, blocked: 2},
  conversion: {pct: 42, converted: 23, leads: 55},
  cancelled: {total: 6, deltaPct: 2.8, solo: 4, clinic: 2},
};

import type {DashboardTrends} from './types';

/** Тренды за 6 месяцев — синхронны сводке (август = текущий срез). */
export const DASHBOARD_TRENDS: DashboardTrends = {
  mrr: [
    {month: '2026-03', value: 872_000},
    {month: '2026-04', value: 948_000},
    {month: '2026-05', value: 1_012_000},
    {month: '2026-06', value: 1_118_000},
    {month: '2026-07', value: 1_206_000},
    {month: '2026-08', value: 1_284_000},
  ],
  activeClients: [
    {month: '2026-03', solo: 96, clinic: 41},
    {month: '2026-04', solo: 104, clinic: 45},
    {month: '2026-05', solo: 112, clinic: 52},
    {month: '2026-06', solo: 121, clinic: 60},
    {month: '2026-07', solo: 130, clinic: 68},
    {month: '2026-08', solo: 138, clinic: 76},
  ],
  leadsToClients: [
    {month: '2026-03', leads: 31, clients: 12},
    {month: '2026-04', leads: 38, clients: 15},
    {month: '2026-05', leads: 42, clients: 17},
    {month: '2026-06', leads: 47, clients: 19},
    {month: '2026-07', leads: 51, clients: 21},
    {month: '2026-08', leads: 55, clients: 23},
  ],
  soloClinicRatio: {solo: 138, clinic: 76},
};
